angular.module('product')
    .directive('productPicker', function ($rootScope, $filter, Product) {
        return {
            require: 'ngModel',
            replace: true,
            scope: {
                onSelect: "&"
            },
            template: `
                <div>
                    <input type="text" class="form-control input-sm text-input" ng-model="selected.name" ng-model-options='{ debounce: 200 }'
                           uib-typeahead="c as (c.name | localized) for c in getProducts($viewValue)"
                           typeahead-on-select="onSelected($item, $model, $label, $event)"
                           typeahead-focus-first="false"
                           title="{{ 'global.name' | translate }}"
                    />
                </div>
            `,
            link: function (scope, $element, $attrs, ngModelCtrl) {

                scope.onSelect = scope.onSelect || angular.noop;
                scope.selected = {};

                scope.onSelected = ($item, $model, $label, $event) => {
                    scope.selected = {
                        id: $item.id,
                        name: $filter('localized')($item.name)
                    };
                    if (angular.isFunction(scope.onSelect())) {
                        scope.onSelect()(scope.selected);
                    }
                };

                scope.getProducts = q => Product.autocomplete(q, 100).then(items => items);


                ngModelCtrl.$render = () => scope.selected = ngModelCtrl.$viewValue;
                ngModelCtrl.$formatters.push(modelValue => modelValue);
                ngModelCtrl.$parsers.push(viewValue => viewValue);

                scope.$watch('selected', () => {
                    ngModelCtrl.$setViewValue(scope.selected);
                    ngModelCtrl.$validate();
                    ngModelCtrl.$render();

                }, true);
            }
        };
    });
